export type MarketingNavLink = {
  label: string;
  href: string;
  hasChevron?: boolean;
};

export const MARKETING_NAV = {
  links: [
    { label: "Features", href: "/#features" },
    { label: "How it works", href: "/#how-it-works" },
    { label: "Pricing", href: "/#pricing" },
    { label: "Guides", href: "/guides" },
    { label: "About us", href: "/#about" },
  ],
  signInLabel: "Sign in",
  primaryCtaLabel: "Generate my first lesson free",
} as const satisfies {
  links: readonly MarketingNavLink[];
  signInLabel: string;
  primaryCtaLabel: string;
};

export const MARKETING_SECTION_SCROLL_MARGIN = "scroll-mt-[92px]";

export function parseMarketingNavHref(href: string): {
  isSectionLink: boolean;
  sectionId: string | null;
  path: string;
} {
  if (href.startsWith("/#")) {
    return { isSectionLink: true, sectionId: href.slice(2), path: "/" };
  }

  if (href.startsWith("#")) {
    return { isSectionLink: true, sectionId: href.slice(1), path: "/" };
  }

  return { isSectionLink: false, sectionId: null, path: href };
}

export function scrollToMarketingSection(
  sectionId: string,
  behavior: ScrollBehavior = "smooth",
) {
  const target = document.getElementById(sectionId);
  if (!target) {
    return false;
  }

  target.scrollIntoView({ behavior, block: "start" });
  window.history.replaceState(null, "", `#${sectionId}`);
  return true;
}
